export function commonFormatPrice(price: string | number) {
  return typeof price === 'number' ? price.toLocaleString('ru') : price;
}
